import { g as r } from "../internals/global.js";
import { d as t } from "../internals/descriptors.js";
import { d as e } from "../internals/define-built-in-accessor.js";
import { r as s } from "../internals/regexp-flags.js";
import { f as i } from "../internals/fails.js";
var n = r.RegExp,
  a = n.prototype;
t && i(function () {
  var r = !0;
  try {
    n(".", "d");
  } catch (t) {
    r = !1;
  }
  var t = {},
    e = "",
    s = r ? "dgimsy" : "gimsy",
    i = function i(r, s) {
      Object.defineProperty(t, r, {
        get: function get() {
          return e += s, !0;
        }
      });
    },
    o = {
      dotAll: "s",
      global: "g",
      ignoreCase: "i",
      multiline: "m",
      sticky: "y"
    };
  for (var l in r && (o.hasIndices = "d"), o) i(l, o[l]);
  return Object.getOwnPropertyDescriptor(a, "flags").get.call(t) !== s || e !== s;
}) && e(a, "flags", {
  configurable: !0,
  get: s
});